__turbopack_context__.v({
  "avatar": "AvatarStack-module__HtyL7a__avatar",
  "avatarHolder": "AvatarStack-module__HtyL7a__avatarHolder",
  "container": "AvatarStack-module__HtyL7a__container",
  "items": "AvatarStack-module__HtyL7a__items",
  "name": "AvatarStack-module__HtyL7a__name",
});
